import "./FeedManagement.scss";
import React, { useState, useEffect } from "react";
import { Page, Spinner, Button, ButtonType } from "../Components";
import { ButtonFrameworkVariant } from "../Components/ButtonFramework";
import { Modal } from "react-bootstrap";
import { awaitJSON, DagLambdaFetch } from "../utils/fetch-utils";

import { useSetError } from "../redux/modals";

interface JobStatus {
  status: string;
  lastmodified?: string;
}

const RUNNING = "RUNNING";

const FeedManagement = (): JSX.Element => {
  const setError = useSetError();
  const [channableSyncStatus, setChannableSyncStatus] = useState<JobStatus | undefined>();
  const [modalMessage, setModalMessage] = useState("");
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);

  useEffect(() => {
    if (channableSyncStatus) {
      return; // already loaded
    }

    (async () => {
      try {
        const searchResults = await DagLambdaFetch("/search?q=CHANNABLE-SYNC-none");
        let parsedResult = await awaitJSON(searchResults);
        setChannableSyncStatus(parsedResult[parsedResult.length - 1]);
        console.log("===> this is from the new tinuiti frontend repo");
      } catch (e) {
        console.error("Failed to fetch ingestions statuses, ERROR: ", e);
        return null;
      }
    })();
  }, [channableSyncStatus]);

  const ModalConfirmation = ({ show }) => {
    return (
      <Modal size="lg" keyboard={false} show={show} onHide={() => setShowModalConfirmation(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{modalMessage}</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button
            type={ButtonType.FILLED}
            variant={ButtonFrameworkVariant.NO_ICON}
            onClick={() => {
              setShowModalConfirmation(false);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <Page title="Feed Management" pageType="Feed Management">
      <div className="channableSyncContainer">
        Channable Sync
        {!channableSyncStatus ? (
          <Spinner />
        ) : (
          <div className="channableSyncStatus">
            {channableSyncStatus?.status === "SUCCEEDED" ? (
              <span className="channableSyncSuccess">
                Last completed: {channableSyncStatus?.lastmodified}
              </span>
            ) : (
              <span className="channableSyncSuccess">Running</span>
            )}
            <Button
              type={ButtonType.FILLED}
              variant={ButtonFrameworkVariant.NO_ICON}
              disabled={!channableSyncStatus || channableSyncStatus?.status === RUNNING}
              onClick={async () => {
                try {
                  await DagLambdaFetch("/start_single_job", {
                    method: "POST",
                    body: {
                      dag: "channable-sync",
                      task: "CHANNABLE-SYNC",
                      task_name: "CHANNABLE-SYNC-none",
                    },
                  });
                  setModalMessage("Channable Sync started successfully.");
                  setShowModalConfirmation(true);

                  setChannableSyncStatus({ status: RUNNING }); // Reset status to trigger re-fetch
                } catch (e) {
                  setError(e as Error);
                }
              }}
            >
              Run Channable Sync
            </Button>
          </div>
        )}
      </div>
      <ModalConfirmation show={showModalConfirmation} />
    </Page>
  );
};

export default FeedManagement;
